import { shiftState } from "./pattern/state";
import { loopFinder } from "./loopfinder";
export class StateCycleManager {
    constructor(p) {
        this.states = loopFinder(p);
    }
    getStatesAtCycle(c) {
        return [this.getStateAtGen(c * 2), this.getStateAtGen(c * 2 + 1)];
    }
    getStateAtGen(g) {
        const loopStartGen = this.states[0].gen;
        const loopLen = this.states.length;
        let idx = (((g - loopStartGen) % loopLen) + loopLen) % loopLen;
        const state = this.states[idx];
        return shiftState(state, g - state.gen);
    }
}
